/**
 * Shared style constants for UI components
 */

export const BACKDROP_STYLE = {
  backgroundColor: 'rgba(52, 64, 84, 0.70);',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
};
